// Базовый shell для авторизованных страниц клиентского портала.
// Sidebar (desktop ≥720px) + topbar + content slot. На mobile sidebar скрыт
// CSS-ом и заменён hamburger-drawer-ом (MobileNav) — см. D09 §1.
import type { ReactNode } from 'react'
import { CartIconButton } from '../features/cart/CartIconButton'
import { PortalCartContextSelector } from '../features/cart/PortalCartContextSelector'
import { usePortalSession } from '../features/invitations/usePortalMembership'
import { ClientBrandBlock } from './ClientBrandBlock'
import { ClientNavLinks, type ClientNavActive } from './ClientNavLinks'
import { MobileNav } from './MobileNav'
import { DistributorContacts } from './DistributorContacts'

export interface ClientShellProps {
  /** Активный пункт меню — управляет визуальным выделением. */
  active: ClientNavActive
  children: ReactNode
  commerceContext?: boolean
}

export function ClientShell({ active, children, commerceContext = true }: ClientShellProps) {
  const session = usePortalSession()
  const currentClient = !session.isError && session.data?.state === 'ACTIVE'
    && ['CLIENT_OWNER', 'CLIENT_EMPLOYEE'].includes(session.data.role)
  const showContext = commerceContext && currentClient && ['catalog', 'cart', 'orders'].includes(active)
  const cartAllowed = showContext && session.data?.permissions.includes('client.cart.use')
  return (
    <div className="client-shell">
      <aside className="client-side" aria-label="Главное меню">
        <ClientBrandBlock />
        <nav aria-label="Разделы портала"><ClientNavLinks active={active} /></nav>
      </aside>

      <div className="client-main">
        <div className="client-mobile-brand"><ClientBrandBlock /></div>
        <header className="client-top">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              minWidth: 0,
            }}
          >
            <MobileNav active={active} />
            <div
              style={{
                fontSize: 13,
                color: 'var(--color-text-secondary)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                minWidth: 0,
              }}
            >
              {showContext && <PortalCartContextSelector />}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}
          >
            {cartAllowed && <CartIconButton />}
            <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>
              {active === 'profile'
                ? 'Профиль'
                : active === 'catalog'
                  ? 'Каталог'
                  : active === 'cart'
                    ? 'Корзина'
                    : active === 'data' ? 'Мои точки и доступ'
                      : active === 'employees' ? 'Сотрудники' : 'Заказы'}
            </div>
          </div>
        </header>
        <DistributorContacts />
        <main className="client-content">{children}</main>
      </div>
    </div>
  )
}
